// extracted by mini-css-extract-plugin
export default {"icon":"CopyText_icon__63Q+-","copySuccess":"CopyText_copySuccess__-xQvx"};